import React, { useContext } from 'react';

import i18n from '@nextroll/ar-i18n';
import { Alerts } from '@nextroll/ar-style-base';

import { NotificationContext } from '../../../hooks/useNotification';

/**
 * This is the general notification component that auto-detect the changes
 * in the notification hook and display newly added alerts accordingly.
 */
export const Notification = () => {
    const { alerts, dismissAlert } = useContext(NotificationContext);

    return (
        <div className='workflows-alert-container'>
            <Alerts
                i18n={i18n}
                contextualAlerts={alerts}
                onDismissContextualAlert={dismissAlert}
            />
        </div>
    );
};
